import React, { useState, useEffect } from "react";
import "./ResourcesStyles.css";
import { Link, useNavigate } from "react-router-dom";
import FAQ from "./FAQ";
import HelpfulMaterials from "./HelpfulMaterials";
import QuickHelp from "./QuickHelp";
import NotFoundPage from "../404/NotFound";

const SidePillItem = ({ text, isActive }) => {
  return (
    <div
      className={`sidepill-item${isActive ? "-active" : ""}`}
      style={{ width: "100%", display: "block" }}
    >
      {text}
    </div>
  );
};
const SwitcherLayout = () => {
  const path = window.location.pathname.split("/resources/");

  try {
    path[1]?.replaceAll("/", "");
  } catch (e) {}
  const navigate = useNavigate();
  const [isActive, setIsActive] = useState(1);
  const pathLookup = {
    "": 1,
    faq: 1,
    "helpful-materials": 2,
    "quick-help": 3,
  };

  const activeComponentLookup = {
    1: <FAQ />,
    2: <HelpfulMaterials />,
    3: <QuickHelp />,
  };

  useEffect(() => {
    if (!path in pathLookup) {
      navigate("/resources/faq");
    }
    setIsActive(pathLookup[path]);
  }, []);
  return (
    <section id="switcher">
      <div
        className="container-fluid row"
        style={{ margin: "0px", padding: "0px" }}
      >
        <div className="col-sm-12 col-md-2 col-lg-2">
          <Link
            to="/resources/faq"
            replace
            onClick={() => {
              setIsActive(1);
            }}
          >
            <SidePillItem text={"FAQ"} isActive={isActive === 1} />
          </Link>
          <Link
            to="/resources/helpful-materials"
            onClick={() => {
              setIsActive(2);
            }}
            replace
          >
            <SidePillItem
              text={"Helpful Materials"}
              isActive={isActive === 2}
            />
          </Link>
          <Link
            to="/resources/quick-help"
            replace
            onClick={() => {
              setIsActive(3);
            }}
          >
            <SidePillItem text={"Quick Help"} isActive={isActive === 3} />
          </Link>
        </div>
        <div className="col-sm-12 col-md-10 col-lg-10">
          {activeComponentLookup[isActive] || <FAQ />}
        </div>
      </div>
    </section>
  );
};

export default SwitcherLayout;
